import { useEffect, useRef, useState } from "react";
import { useInstagramEmbed } from "../hooks/useInstagramEmbed";

interface InstagramEmbedProps {
  postUrl: string;
}

export default function InstagramEmbed({ postUrl }: InstagramEmbedProps) {
  const { processEmbeds } = useInstagramEmbed();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      processEmbeds();
    }, 100);
    return () => clearTimeout(timer);
  }, [processEmbeds]);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const observer = new MutationObserver(() => {
      const iframe = wrapper.querySelector("iframe");
      if (iframe) {
        iframe.addEventListener(
          "load",
          () => setTimeout(() => setLoaded(true), 2000),
          { once: true },
        );
        if (iframe.contentDocument?.readyState === "complete") {
          setTimeout(() => setLoaded(true), 2000);
        }
        observer.disconnect();
      }
    });

    observer.observe(wrapper, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="instagram-embed-outer">
      <div ref={wrapperRef} className="instagram-embed-wrapper">
        <div
          className={`instagram-skeleton${loaded ? " instagram-skeleton--hidden" : ""}`}
          aria-hidden="true"
        />
        <blockquote
          className="instagram-media"
          data-instgrm-captioned
          data-instgrm-permalink={postUrl}
          data-instgrm-version="14"
        >
          <a href={postUrl} target="_blank" rel="noopener noreferrer">
            {" "}
          </a>
        </blockquote>
      </div>
    </div>
  );
}
